import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Title from '../Common/Title';

function preventDefault(event) {
  event.preventDefault();
}

// Rename to ValueBox and add props for title, value, and optional date
export default function ValueBox({ title, value, date = null }) {
  return (
    <React.Fragment>
      <Title>{title}</Title>
      <Typography component="p" variant="h4">
        {value}
      </Typography>
      {date && (
        <Typography color="text.secondary" sx={{ flex: 1 }}>
          on {date}
        </Typography>
      )}
    </React.Fragment>
  );
}